import { Div, P, Input, Button, Span, reactive } from 'alkali'
import Dialog from '../generic/DialogAlkali'
import { studyCollection } from '../../model/StudyCollection'
import './GroupingDialog.scss'

const searchForTarget = (targetString) => {
	targetString = targetString.toUpperCase()
	const targetStudies = []
	for (let study of studyCollection.valueOf()) {
		let author = (study.author && study.author.length > 0) ? study.author.toUpperCase() : ''
		if (author.includes(targetString) || study.acronyms.some(acronym => acronym.includes(targetString))) {
			targetStudies.push(study)
		}
	}
	return targetStudies
}

export default class GroupReassignmentDialog extends Dialog('.grouping-dialog') {
	get defaults() {
		return {
			head: {},
			id: 'grouping-dialog',
			size: '45%',
			foot: {}
		}
	}
	
	ready(properties) {

		const { 
			study: studyToChange, 
			relocatePublication,
		} = properties

		this.header.append(
			Div('.header-container', [
				P('.header-title', [`Reassign ${studyToChange.name} - ${studyToChange.year}`]),
			])
		)

		let searchString = reactive('')
		let body = this.body
		this.body.append(
			Div('.search-container', [
				P('.search-header', ['Search for studies by author or acronym']), 
				Div('.search-input', [
					Input({
						oninput: (e) => {
							searchString.put(e.target.value)
						}
					}),
					Button('.btn.primary', {
						onclick: () => {
							// clear existing study list
							document.querySelectorAll('.target-study').forEach(study => study.remove())

							const targetStudies = searchForTarget(searchString)
							if (targetStudies && targetStudies.length > 1) {
								for (let study of targetStudies) {
									body.append(
										P('.target-study', [
											Div('study-info', [Span('.title', `${study.valueOf().name} - ${study.valueOf().year}: `), study.valueOf().title]), 
											Div('.assign-button', [Button('.btn.secondary', { 
													onclick() { 
														relocatePublication(study.valueOf(), studyToChange)
														document.querySelector('.grouping-dialog').hide() 
													}
												}, ['Assign'])
											
											])
										])
									)
								}
							} else if (targetStudies && targetStudies.length == 1) {
								let targetStudy = targetStudies[0]
								body.append(
									P('.target-study', [
										Div('study-info', [Span('.title', `${targetStudy.name} - ${targetStudy.year}: `), targetStudy.title]), 
										Div('.assign-button', [Button('.btn.secondary', { 
												onclick() { 
													relocatePublication(targetStudy, studyToChange)
													document.querySelector('.grouping-dialog').hide() 
												}
											}, ['Assign'])

										])
									])
								)
							}
						}
					}, ['Search'])
				])
			]),
			
		)
		for (let study of studyCollection.valueOf()) {
			body.append(
				P('.target-study', [
					Div('study-info', [Span('.title', `${study.valueOf().name} - ${study.valueOf().year}: `), study.valueOf().title]), 
					Div('.assign-button', [Button('.btn.secondary', { 
							onclick() { 
								relocatePublication(study.valueOf(), studyToChange)
								document.querySelector('.grouping-dialog').hide() 
							}
						}, ['Assign'])
					
					])
				])
			)
		}
	}

	show() {
		super.show()
	}
}

